export default __webpack_public_path__ + "static/czarne_wiosła-6815c013d9c82a57a95610fc7fb6ae90.svg";